import Cookies from "universal-cookie";
import { Ilogin } from "./AuthService";


const cookie = new Cookies();

class CookieService {

    getUser(key: object){

        return cookie.getAll(key);
    }

    get(key: string){

        return cookie.get(key);
    }

    set(key: string, value: string, options: Object){
        cookie.set(key, value, options);
    }

    setUser(key: string, value: Ilogin, options: Object){
        cookie.set(key, value, options);
    }

    remove(key: string){
        cookie.remove(key);
    }
}

export default new CookieService();